<template>
    <div class="r-auth-login">
        <y-form-title
            :title="formTitle"
            :description="formDescription"
            :description-link="formDescriptionLink"
            :color="color"
        />

        <y-loading
            :active="$wait.is('fetch-config')"
            position="relative"
            height="100%"
        >
            <y-validator
                v-if="!isEmpty(configs)"
                @submit="login"
            >
                <y-input
                    v-if="configs.username"
                    v-model="model.username"
                    type="text"
                    name="username"
                    :format="formFieldOptions('username').format"
                    :label="formFieldOptions('username').label"
                    :placeholder="formFieldOptions('username').placeholder"
                    class="mb-10"
                />

                <y-input
                    v-model="model.password"
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    :label="$t('fields.password')"
                    :placeholder="$t('fields.password')"
                    :validation="configs.password.validation"
                    :icon-append="showPassword ? 'eye-slash' : 'eye'"
                    :icon-append-action="showPasswordChars"
                    icon-prefix="far"
                    class="mb-10"
                />

                <!-- Remember Me -->
                <y-checkbox
                    v-if="configs.remember_me === '1'"
                    v-model="model.remember_me"
                    :color="color"
                    :label="$t('auth.login.remember_me')"
                    class="mb-6"
                />

                <!-- Forget Password Link -->
                <router-link
                    class="d-block typo-body-2 mb-10"
                    :class="[`color-${color}-text`]"
                    :to="forgetRoute"
                >
                    {{ $t('auth.forget.link') }}
                </router-link>

                <!-- Recaptcha -->
                <y-recaptcha
                    v-if="configs.recaptcha && configs.recaptcha.active"
                    ref="recaptcha"
                    :site-key="configs.recaptcha.key"
                    :size="configs.recaptcha.size"
                    @verify="beforeLogin"
                />

                <!-- Login Button -->
                <y-button
                    block
                    flat
                    :color="color"
                    type="submit"
                    :disabled="!model.username || !model.password"
                    loading-on="login-form"
                >
                    {{ $t('auth.login.button') }}
                </y-button>
            </y-validator>
        </y-loading>
    </div>
</template>

<script>
    import {
        YValidator, YInput, YCheckbox,
    } from '@components';
    import AuthLoginMixin from '@rogues/Auth/mixins/Login';
    import isEmpty from 'lodash.isempty';

    export default {
        name: 'LoginFormBlock',

        components: {
            YValidator,
            YInput,
            YCheckbox,
        },

        mixins: [
            AuthLoginMixin,
        ],

        methods: {
            isEmpty,
        },
    };
</script>
